<div class="crime-picker" [class.is-error]="invalid">

    <div class="crime-picker__title" *ngIf="showTitle">{{ titleText }}</div>
    <div class="crime-picker__subtitle" *ngIf="subtitlePosition === 'above'">{{ subtitleText }}</div>

    <div class="crime-picker__pills"
         *ngIf="variant === 'pills'"
         role="group"
         [attr.aria-label]="titleText">

        <!-- type="button": this renders inside the register <form>, where a bare
             button would default to submit and fire the form on every tap. -->
        <button *ngFor="let crimeType of crimeTypes"
                type="button"
                class="crime-picker__pill"
                [class.is-selected]="isSelected(crimeType.id)"
                [attr.aria-pressed]="isSelected(crimeType.id)"
                [disabled]="isOptionDisabled(crimeType)"
                (click)="toggle(crimeType.id)">
            {{ crimeType.name }}
        </button>

    </div>

    <div class="crime-picker__checks"
         *ngIf="variant === 'checkboxes'"
         role="group"
         [attr.aria-label]="titleText">

        <ion-checkbox *ngFor="let crimeType of crimeTypes"
                      class="crime-picker__check ion-text-wrap"
                      mode="md"
                      labelPlacement="end"
                      justify="start"
                      [checked]="isSelected(crimeType.id)"
                      [disabled]="isOptionDisabled(crimeType)"
                      (ionChange)="toggle(crimeType.id)">
            {{ crimeType.name }}
        </ion-checkbox>

    </div>

    <div class="crime-picker__subtitle crime-picker__subtitle--below"
         *ngIf="subtitlePosition === 'below'">
        {{ subtitleText }}
    </div>

</div>
